import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Input, Label, Alert, Button } from "reactstrap";
import { saveAppointment } from "./Axios";

const AppointmentForm = ({ stage, setApplicanttHit, showNotification, toggle }) => {
  const appointment = stage ? stage.appointment : null;

  // Función para formatear la fecha en "YYYY-MM-DD"
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toISOString().split("T")[0];
  };

  // Función para formatear la hora en "HH:mm"
  const formatTime = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toTimeString().split(" ")[0].slice(0, 5);
  };

  // Estados del formulario
  const [appointmentDate, setAppointmentDate] = useState(
    appointment ? formatDate(appointment.appointmentDate) : ""
  );

  const [appointmentTime, setAppointmentTime] = useState(
    appointment ? formatTime(appointment.appointmentDate) : ""
  );

  const [address, setAddress] = useState(appointment ? appointment.address : "");
  const [managerName, setManagerName] = useState(appointment ? appointment.managerName : "");
  const [managerContact, setManagerContact] = useState(
    appointment ? appointment.managerContact : ""
  );
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const currentAppointment = stage ? stage.appointment : null;
    
    if (currentAppointment) {
      setAppointmentDate(formatDate(currentAppointment.appointmentDate));
      setAppointmentTime(formatTime(currentAppointment.appointmentDate));
      setAddress(currentAppointment.address || "");
      setManagerName(currentAppointment.managerName || "");
      setManagerContact(currentAppointment.managerContact || "");
    } else {
      setAppointmentDate("");
      setAppointmentTime("");
      setAddress("");
      setManagerName("");
      setManagerContact("");
    }
  }, [
    stage?.appointment?.id,
    stage?.appointment?.appointmentDate,
    stage?.appointment?.address,
    stage?.appointment?.managerName,
    stage?.appointment?.managerContact,
    stage?.id
  ]);

  const handleSubmit = () => {
    if (
      appointmentDate === "" ||
      appointmentTime === "" ||
      address.trim() === "" ||
      managerName.trim() === "" ||
      managerContact.trim() === ""
    ) {
      setError(true);
      return;
    }

    setLoading(true);

    const appointmentDateTime = new Date(`${appointmentDate}T${appointmentTime}:00`);

    if (isNaN(appointmentDateTime.getTime())) {
      setError(true);
      setLoading(false);
      return;
    }

    const appointmentISO = appointmentDateTime.toISOString();

    let data = new FormData();
    if (appointment) {
      data.append("interview_appointment[id]", appointment.id);
    }
    data.append("interview_appointment[interview_stage_id]", stage.id);
    data.append("interview_appointment[appointment_date]", appointmentISO);
    data.append("interview_appointment[address]", address);
    data.append("interview_appointment[manager_name]", managerName);
    data.append("interview_appointment[manager_contact]", managerContact);

    // Llamar al servicio para guardar la cita
    saveAppointment(data, (response) => {
      if (!response) {
        setLoading(false);
        setError(true);
        showNotification("Error", "Ocurrió un error al guardar la cita. Por favor intenta de nuevo.", "danger");
        return;
      }
      
      if (response.status === 201 || response.status === 200) {
        setApplicanttHit(response.data);
        showNotification("Genial", "Entrevista agendada exitosamente!", "success");
        setLoading(false);
        toggle();
      } else if (response.status === 422) {
        setLoading(false);
        setError(true);
        showNotification("Error", "Por favor verifica que todos los campos estén correctos.", "danger");
      } else {
        setLoading(false);
        setError(true);
        showNotification("Error", "Ocurrió un error al guardar la cita.", "danger");
      }
    });
  };

  return (
    <Fragment>
      <h5 className="font-weight-bold text-muted">Datos de la Entrevista</h5>
      {error && <Alert color="danger">Todos los campos son obligatorios!</Alert>}
      <Row>
        <Col md="6">
          <Label className="input_required">Fecha de la Entrevista</Label>
          <Input
            id="appointmentDate"
            name="appointmentDate"
            type="date"
            onChange={(e) => setAppointmentDate(e.target.value)}
            value={appointmentDate}
          />
        </Col>
        <Col md="6">
          <Label className="input_required">Hora de la Entrevista</Label>
          <Input
            id="appointmentTime"
            name="appointmentTime"
            type="time"
            onChange={(e) => setAppointmentTime(e.target.value)}
            value={appointmentTime}
          />
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Label className="input_required">Dirección</Label>
          <Input type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col md="6">
          <Label className="input_required">Persona a Cargo</Label>
          <Input type="text" value={managerName} onChange={(e) => setManagerName(e.target.value)} />
        </Col>
        <Col md="6">
          <Label className="input_required">Email y/o Teléfono de contacto</Label>
          <Input
            type="text"
            value={managerContact}
            onChange={(e) => setManagerContact(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3 text-right">
        <Col md="12">
          <Button size="sm" onClick={handleSubmit} disabled={loading}>
            <i className="fas fa-calendar-alt" />{" "}
            {loading ? "Agendando" : appointment ? "Reagendar" : "Agendar"}
            {loading ? <i className="fas fa-spinner fa-pulse ml-2"></i> : null}
          </Button>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AppointmentForm;
